import { server } from "../api";
import axios from "axios";
const UploadImage = async (file) => {
  let data = new FormData();
  data.append("file", file, file.name);
  let response = await axios.post(server + "image/upload", data, {
    headers: {
      accept: "application/json",
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
    },
  });
  return server.substring(0, server.length - 1) + response.data;
};

export default { UploadImage };
